export class HeightChangeProcessor {
    /**
     * Process height change event action from postMessage
     */
    static process({ message }) {
        if (!message) {
            return;
        }
        const iframeContainer = message.caller && document.getElementById(`${message.caller}-container`);
        const newHeight = message.content;
        if (iframeContainer) {
            iframeContainer.style.height = newHeight + 'px';
        }
    }
}
